import React from 'react';
import '../css/MiniCalendar.css';
import { FaCalendarAlt } from 'react-icons/fa';

const CustomCalendar2 = (props) => {
    return (
        <div className={"mini-container " + props.extraClass} onClick={() => { props.onClick() }}>
            <input value={props.value} readOnly />
            <FaCalendarAlt className="mini-icon" />
        </div>
    );
}

export default CustomCalendar2;